import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAPCU1VzsViytNcfw0KA7E_sqqjlft1k4s",
  authDomain: "carbooking-112fd.firebaseapp.com",
  databaseURL: "https://carbooking-112fd-default-rtdb.firebaseio.com",
  projectId: "carbooking-112fd",
  storageBucket: "carbooking-112fd.firebasestorage.app",
  messagingSenderId: "40835703924",
  appId: "1:40835703924:web:ebc63a0170a1d7324a9d21"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

export default app;

